import { Box, Stack, Typography } from '@mui/material';

const getProductCode = (item) =>
  item?.attributes?.id_item?.data?.attributes?.mexal_code || '-';

const getProductDescription = (item) => {
  const nameITA = item?.attributes?.id_item?.data?.attributes?.name_ITA || '-';
  const nameENG = item?.attributes?.id_item?.data?.attributes?.name_ENG || '-';
  return nameENG ? `${nameITA} (${nameENG})` : nameITA;
};

const getProductUM = (item) =>
  item?.attributes?.id_item?.data?.attributes?.main_unit_measure || '-';

const getProductQuantity = (item) => item?.attributes?.quantity || '-';

const SendOfMexalPreview = ({ items = [], mexalCode, nameSupplier, currentDate, number }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: 1,
        minHeight: '30px',
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          pb: 2,
        }}
      >
        <Stack spacing={2}>
          <Box>
            <Typography variant='body2'>
              <span style={{ fontWeight: 700, marginRight: '8px' }}>Document:</span>
              <span style={{ fontWeight: 600 }}>OF</span>
            </Typography>
          </Box>
          <Box>
            <Typography variant='body2'>
              <span style={{ fontWeight: 700, marginRight: '8px' }}>Number:</span>
              <span style={{ fontWeight: 600 }}>{number ?? 0}</span>
            </Typography>
          </Box>
          <Box>
            <Typography variant='body2'>
              <span style={{ fontWeight: 700, marginRight: '8px' }}>Supplier:</span>
              <span style={{ fontWeight: 600 }}>{`${mexalCode || '-'} - ${nameSupplier || '-'}`}</span>
            </Typography>
          </Box>
          <Box>
            <Typography variant='body2'>
              <span style={{ fontWeight: 700, marginRight: '8px' }}>Date:</span>
              <span style={{ fontWeight: 600 }}>{currentDate}</span>
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Stack spacing={1.5}>
        <Typography variant='subtitle2' sx={{ fontWeight: 600 }}>
          Products ({items?.length || 0})
        </Typography>
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            overflowX: 'auto',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '2fr 1fr 1fr',
              bgcolor: 'grey.100',
              px: 2,
              py: 1.5,
              gap: 2,
            }}
          >
            <Typography variant='caption' sx={{ fontWeight: 700, letterSpacing: 0.3 }}>
              CODE & DESCRIPTION
            </Typography>
            <Typography variant='caption' sx={{ fontWeight: 700, letterSpacing: 0.3 }}>
              UM
            </Typography>
            <Typography variant='caption' sx={{ fontWeight: 700, letterSpacing: 0.3 }}>
              QUANTITY
            </Typography>
          </Box>

          {(items || []).map((item, index) => (
            <Box
              key={item?.id}
              sx={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr 1fr',
                px: 2,
                py: 1.5,
                gap: 2,
                borderTop: '1px solid',
                borderColor: 'divider',
                bgcolor: index % 2 === 0 ? 'background.paper' : 'grey.50',
              }}
            >
              <Box>
                <Typography variant='body2' sx={{ fontWeight: 600 }}>
                  {getProductCode(item)}
                </Typography>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  {getProductDescription(item)}
                </Typography>
              </Box>
              <Typography variant='body2'>{getProductUM(item)}</Typography>
              <Typography variant='body2' sx={{ fontWeight: 600, color: 'primary.main' }}>
                {getProductQuantity(item)}
              </Typography>
            </Box>
          ))}

          {(!Array.isArray(items) || items.length === 0) && (
            <Box sx={{ p: 2 }}>
              <Typography variant='body2' color='text.secondary'>
                No products available for this supplier.
              </Typography>
            </Box>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default SendOfMexalPreview;
